import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-875379f8")

_pushScopeId("data-v-875379f8")
const _hoisted_1 = { class: "device-connection" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.canConnect('http'))
      ? (_openBlock(), _createBlock("a", {
          key: 0,
          class: "btn success",
          href: "#",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.connect('http')))
        }, "http"))
      : _createCommentVNode("", true),
    (_ctx.canConnect('https'))
      ? (_openBlock(), _createBlock("a", {
          key: 1,
          class: "btn success",
          href: "#",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.connect('https')))
        }, "https"))
      : _createCommentVNode("", true)
  ]))
})